import { useEffect } from "react";
import { v4 as uuidv4 } from "uuid";
import db from "../database";
import { getWorkflowRules } from "../services/generic";
import { syncSingleProductByValue } from "../services";
import { Modal } from "antd";
import NotFoundImg from "../assets/images/NotFoundImg.svg";
import { stock } from "../../src/components/PointOfSale/Core/stock.js";
import useAuthStore from "../stores/useAuthStore";

const BarCodeHandler = (props) => {
  const { setCustomMixItems, cart, setCart, setProductStock, setShowCompleteSaleStock, setCompleteSaleStockData } = props;
  const tillData = useAuthStore.getState().tillData;
  let dataString = "";
  let timeoutId;

  const handleKeyDown = (e) => {
    const { key } = e;

    // Reset timeout if it exists
    if (timeoutId !== undefined) {
      clearTimeout(timeoutId);
    }

    // Set a timeout to clear dataString after inactivity
    timeoutId = setTimeout(() => {
      dataString = "";
      timeoutId = undefined;
    }, 200);

    // Handle Backspace
    if (key === "Backspace") {
      dataString = dataString.slice(0, -1);
    }

    // Append character to dataString if it's alphanumeric or allowed symbols
    if (key.length === 1 && ((key >= "0" && key <= "9") || (key >= "A" && key <= "Z") || (key >= "a" && key <= "z") || key === "-" || key === " ")) {
      dataString += key;
    }

    // Process barcode when Enter (charCode 13) is pressed
    if (key === "Enter" && dataString !== "" && localStorage.getItem("productName") === null) {
      // Skip when focus is on an editable element — the keystrokes belong to
      // that input (e.g. mix search box, weight popup numpad), not a barcode
      // scanner. Without this gate, pressing Enter while typing inside the
      // CustomMix search or weight popup pushed accumulated keystrokes through
      // barcodeScanFromConfig and silently added items to the mix in the
      // background. (Tab8 issue #11)
      const ae = typeof document !== "undefined" ? document.activeElement : null;
      const tag = ae?.tagName;
      const isEditable = tag === "INPUT" || tag === "TEXTAREA" || ae?.isContentEditable === true;
      if (isEditable) {
        dataString = "";
        return;
      }

      // Log the scanned data for debugging
      console.debug("Scanned QR code:", dataString);

      // Process the entire dataString
      console.debug("barcode ------------>", dataString.trim());
      barcodeScanFromConfig(dataString.trim());

      // Reset state
      dataString = "";
    }
  };

  const mergeCompleteSaleStockData = (newList) => {
    setCompleteSaleStockData((prev = []) => {
      const prevArr = Array.isArray(prev) ? prev : [];
      const nextArr = Array.isArray(newList) ? newList : [];

      const merged = [...prevArr];

      nextArr.forEach((item) => {
        const key = `${item.productId}_${item.mBatchId || ""}`;

        const idx = merged.findIndex((x) => `${x.productId}_${x.mBatchId || ""}` === key);

        if (idx === -1) {
          merged.push(item);
        } else {
          merged[idx] = item;
        }
      });

      return merged;
    });
  };

  const getProduct = async (formula, newData, tillData, config) => {
    let productValue = newData.substr(Number(formula.property["product.value"]?.position - 1), Number(formula.property["product.value"]?.length));

    productValue = config?.delimiter ? productValue.replace(/^0+/, "") : productValue;

    const operators = ["+", "-", "/", "*"];
    const operatorFunctions = {
      "+": (a, b) => a + b,
      "-": (a, b) => a - b,
      "*": (a, b) => a * b,
      "/": (a, b) => a / b,
    };

    // On-demand single-product sync (roadmap bc3b9831 / ad6b7339): fetch the
    // scanned product from backend once if it's not in local DB.
    try {
      const existing = await db.products.where("value").equalsIgnoreCase(productValue).first();
      if (!existing && tillData?.tillAccess?.csBunit?.csBunitId) {
        await syncSingleProductByValue(
          tillData,
          uuidv4(),
          tillData?.tillAccess?.cwrTill?.cwrTillID,
          productValue
        );
      }
    } catch (err) {
      console.warn("[BarcodeGroupedHandler] single-product sync failed:", err?.message);
    }

    const allProductArr = await db.products
      .where("value")
      .equalsIgnoreCase(productValue)
      .toArray();
    const productArr = allProductArr.filter((product) => product.isactive == true && product.productSegment !== "BG");
    const product = productArr[0];

    console.debug("Product search result:", product, "for value:", productValue);

    const uomData = product?.uomData?.[0];
    const currenciesList = tillData.tillAccess.csBunit.currencies;

    let orderNo = "";
    let cartlineQty;
    let cartlineUnitprice;
    let cartlineTotal;
    let scanFlag = false;

    // ---------- QTY ----------
    if (formula.property["cartline.qty"] !== undefined) {
      if (typeof formula.property["cartline.qty"] === "number") {
        cartlineQty = formula.property["cartline.qty"];
      } else if (typeof formula.property["cartline.qty"] === "string") {
        const foundOperator = operators.find((op) => formula.property["cartline.qty"].includes(op));
        const splitArr = formula.property["cartline.qty"].split(foundOperator);

        let qtyArr = splitArr.map((splitItem) => {
          let value;

          if (splitItem.includes("cartline")) {
            if (splitItem.includes("qty")) {
              if (typeof formula.property["cartline.qty"] === "number") {
                value = formula.property["cartline.qty"];
              } else if (typeof formula.property["cartline.qty"] === "object") {
                value = parseFloat(
                  (
                    Number(newData.substr(Number(formula.property["cartline.qty"]?.position - 1), Number(formula.property["cartline.qty"]?.length))) /
                    (uomData && uomData.decimal === "Y" ? Math.pow(10, uomData.stdprecision) : 1)
                  ).toFixed(uomData && uomData.decimal === "Y" ? uomData.stdprecision : 3)
                );
              }
            } else if (splitItem.includes("total")) {
              if (typeof formula.property["cartline.total"] === "number") {
                value = formula.property["cartline.total"];
              } else if (typeof formula.property["cartline.total"] === "object") {
                value = parseFloat(
                  (
                    Number(newData.substr(Number(formula.property["cartline.total"]?.position - 1), Number(formula.property["cartline.total"]?.length))) /
                    (currenciesList[0]?.stdPrecision ? Math.pow(10, currenciesList[0].stdPrecision) : 100)
                  ).toFixed(currenciesList[0].stdPrecision ? currenciesList[0].stdPrecision : 2)
                );
              }
            } else if (splitItem.includes("unitprice")) {
              if (typeof formula.property["cartline.unitprice"] === "number") {
                value = formula.property["cartline.unitprice"];
              } else if (typeof formula.property["cartline.unitprice"] === "object") {
                value = parseFloat(
                  (
                    Number(newData.substr(Number(formula.property["cartline.unitprice"]?.position - 1), Number(formula.property["cartline.unitprice"]?.length))) /
                    (currenciesList[0]?.stdPrecision ? Math.pow(10, currenciesList[0].stdPrecision) : 100)
                  ).toFixed(currenciesList[0].stdPrecision ? currenciesList[0].stdPrecision : 2)
                );
              }
            }
          } else {
            value = product.sunitprice;
          }

          return value;
        });

        cartlineQty = operatorFunctions[foundOperator](qtyArr[0], qtyArr[1]);
      } else if (typeof formula.property["cartline.qty"] === "object") {
        cartlineQty = parseFloat(
          (
            Number(newData.substr(Number(formula.property["cartline.qty"]?.position - 1), Number(formula.property["cartline.qty"]?.length))) /
            (uomData && uomData.decimal === "Y" ? Math.pow(10, uomData.stdprecision) : 1)
          ).toFixed(uomData && uomData.decimal === "Y" ? uomData.stdprecision : 3)
        );
      }
    }

    // ---------- UNIT PRICE ----------
    if (formula.property["cartline.unitprice"] !== undefined) {
      if (typeof formula.property["cartline.unitprice"] === "number") {
        cartlineUnitprice = formula.property["cartline.unitprice"];
      } else if (typeof formula.property["cartline.unitprice"] === "string") {
        const foundOperator = operators.find((op) => formula.property["cartline.unitprice"].includes(op));
        const splitArr = formula.property["cartline.unitprice"].split(foundOperator);

        let unitpriceArr = splitArr.map((splitItem) => {
          let value;

          if (splitItem.includes("cartline")) {
            if (splitItem.includes("qty")) {
              if (typeof formula.property["cartline.qty"] === "number") {
                value = formula.property["cartline.qty"];
              } else if (typeof formula.property["cartline.qty"] === "object") {
                value = parseFloat(
                  (
                    Number(newData.substr(Number(formula.property["cartline.qty"]?.position - 1), Number(formula.property["cartline.qty"]?.length))) /
                    (uomData && uomData.decimal === "Y" ? Math.pow(10, uomData.stdprecision) : 1)
                  ).toFixed(uomData && uomData.decimal === "Y" ? uomData.stdprecision : 3)
                );
              }
            } else if (splitItem.includes("total")) {
              if (typeof formula.property["cartline.total"] === "number") {
                value = formula.property["cartline.total"];
              } else if (typeof formula.property["cartline.total"] === "object") {
                value = parseFloat(
                  (
                    Number(newData.substr(Number(formula.property["cartline.total"]?.position - 1), Number(formula.property["cartline.total"]?.length))) /
                    (currenciesList[0]?.stdPrecision ? Math.pow(10, currenciesList[0].stdPrecision) : 100)
                  ).toFixed(currenciesList[0].stdPrecision ? currenciesList[0].stdPrecision : 2)
                );
              }
            } else if (splitItem.includes("unitprice")) {
              if (typeof formula.property["cartline.unitprice"] === "number") {
                value = formula.property["cartline.unitprice"];
              } else if (typeof formula.property["cartline.unitprice"] === "object") {
                value = parseFloat(
                  (
                    Number(newData.substr(Number(formula.property["cartline.unitprice"]?.position - 1), Number(formula.property["cartline.unitprice"]?.length))) /
                    (currenciesList[0]?.stdPrecision ? Math.pow(10, currenciesList[0].stdPrecision) : 100)
                  ).toFixed(currenciesList[0].stdPrecision ? currenciesList[0].stdPrecision : 2)
                );
              }
            }
          } else {
            value = product.sunitprice;
          }

          return value;
        });

        cartlineUnitprice = operatorFunctions[foundOperator](unitpriceArr[0], unitpriceArr[1]);
      } else {
        cartlineUnitprice = parseFloat(
          (
            Number(newData.substr(Number(formula.property["cartline.unitprice"]?.position - 1), Number(formula.property["cartline.unitprice"]?.length))) /
            (currenciesList[0]?.stdPrecision ? Math.pow(10, currenciesList[0].stdPrecision) : 100)
          ).toFixed(currenciesList[0].stdPrecision ? currenciesList[0].stdPrecision : 2)
        );
      }
    }

    // ---------- TOTAL ----------
    if (formula.property["cartline.total"] !== undefined) {
      if (typeof formula.property["cartline.total"] === "number") {
        cartlineTotal = formula.property["cartline.total"];
      } else if (typeof formula.property["cartline.total"] === "string") {
        const foundOperator = operators.find((op) => formula.property["cartline.total"].includes(op));
        const splitArr = formula.property["cartline.total"].split(foundOperator);

        let totalArr = splitArr.map((splitItem) => {
          let value;

          if (splitItem.includes("cartline")) {
            if (splitItem.includes("qty")) {
              if (typeof formula.property["cartline.qty"] === "number") {
                value = formula.property["cartline.qty"];
              } else if (typeof formula.property["cartline.qty"] === "object") {
                value = parseFloat(
                  (
                    Number(newData.substr(Number(formula.property["cartline.qty"]?.position - 1), Number(formula.property["cartline.qty"]?.length))) /
                    (uomData && uomData.decimal === "Y" ? Math.pow(10, uomData.stdprecision) : 1)
                  ).toFixed(uomData && uomData.decimal === "Y" ? uomData.stdprecision : 3)
                );
              }
            } else if (splitItem.includes("total")) {
              if (typeof formula.property["cartline.total"] === "number") {
                value = formula.property["cartline.total"];
              } else if (typeof formula.property["cartline.total"] === "object") {
                value = parseFloat(
                  (
                    Number(newData.substr(Number(formula.property["cartline.total"]?.position - 1), Number(formula.property["cartline.total"]?.length))) /
                    (currenciesList[0]?.stdPrecision ? Math.pow(10, currenciesList[0].stdPrecision) : 100)
                  ).toFixed(currenciesList[0].stdPrecision ? currenciesList[0].stdPrecision : 2)
                );
              }
            } else if (splitItem.includes("unitprice")) {
              if (typeof formula.property["cartline.unitprice"] === "number") {
                value = formula.property["cartline.unitprice"];
              } else if (typeof formula.property["cartline.unitprice"] === "object") {
                value = parseFloat(
                  (
                    Number(newData.substr(Number(formula.property["cartline.unitprice"]?.position - 1), Number(formula.property["cartline.unitprice"]?.length))) /
                    (currenciesList[0]?.stdPrecision ? Math.pow(10, currenciesList[0].stdPrecision) : 100)
                  ).toFixed(currenciesList[0].stdPrecision ? currenciesList[0].stdPrecision : 2)
                );
              }
            }
          } else {
            value = product.sunitprice || 0;
          }

          return value;
        });

        cartlineTotal = operatorFunctions[foundOperator](totalArr[0], totalArr[1]);
      } else {
        cartlineTotal = parseFloat(
          (
            Number(newData.substr(Number(formula.property["cartline.total"]?.position - 1), Number(formula.property["cartline.total"]?.length))) /
            (currenciesList[0]?.stdPrecision ? Math.pow(10, currenciesList[0].stdPrecision) : 100)
          ).toFixed(currenciesList[0].stdPrecision ? currenciesList[0].stdPrecision : 2)
        );
      }
    }

    // ---------- ORDER NO ----------
    if (formula.property["production.orderNo"] !== undefined) {
      orderNo = newData.substr(Number(formula.property["production.orderNo"]?.position - 1), Number(formula.property["production.orderNo"]?.length));
    }

    // ---------- PRODUCT UNIT PRICE (event) ----------
    if (formula.property["product.unitprice"] !== undefined) {
      if (formula.property["product.unitprice"]?.type === "event") {
        const workflowRules = await db.POSWorkFlowRules.toArray();
        if (workflowRules && workflowRules.length > 0) {
          await Promise.all(
            workflowRules.map(async (res) => {
              if (res.eventId === "productPriceOnScan") {
                if (res.apiSource === "APB") {
                  const value = { orderno: orderNo, value: productValue };
                  const newStringifiedFields = JSON.stringify(value).replace(/\\"/g, '\\"');
                  const newStringRequest = JSON.stringify(newStringifiedFields);
                  const apiBuilder = {
                    query: `mutation ExecuteAPIBuilder($apiBuilderId: String, $params: String) { executeAPIBuilder(apiBuilderId: $apiBuilderId, params: $params)}`,
                    variables: { apiBuilderId: res.apiEndPoint, params: newStringifiedFields },
                  };
                  const apiBuilderResponse = await getWorkflowRules(apiBuilder);

                  if (apiBuilderResponse.data.data.executeAPIBuilder.length > 0) {
                    const response = JSON.parse(apiBuilderResponse.data.data.executeAPIBuilder);

                    product.mBatchId = response?.length > 0 ? response[0]?.m_batch_id : null;
                    product.batchno = response?.length > 0 ? response[0]?.batch_no : null;

                    cartlineUnitprice = parseFloat(response?.length > 0 ? response[0].sale_price.toFixed(currenciesList[0].stdPrecision || 2) : 0);
                  }
                } else if (res.apiSource === "RES") {
                  console.debug("-------------->Retail");
                } else if (res.apiSource === "CAP") {
                  console.debug("-------------->Core");
                }
              }
            })
          );
        }
      }
    }

    if (cartlineUnitprice || cartlineTotal) {
      scanFlag = true;
    }

    return {
      ...product,
      weight: cartlineQty,
      rawWeight: cartlineQty,
      sunitprice: cartlineUnitprice || product.sunitprice,
    };
  };

  const barcodeScanFromConfig = async (data) => {
    const customMix = localStorage.getItem("customMix");
    console.debug("custom mix ==========>", customMix);
    if (customMix !== "CM") {
      console.debug("customMix is not 'CM' – skipping custom mix scan flow for:", data);
      return;
    }
    try {
      // setCompleteSaleStockData([]);
      // setShowCompleteSaleStock(false);
      console.debug("Processing QR code:", data);
      let productsToProcess = [data];
      const posConfig = tillData?.posScanConfigs?.filter((item) => item.formula !== null && item.scanTrxType === "PR");

      if (posConfig?.length > 0) {
        const posConfigItem = posConfig.filter((item) => data.startsWith(item.startsWith));
        if (posConfigItem?.length > 0) {
          console.debug("Using posScanConfig:", posConfigItem[0]);
          const config = posConfigItem[0];
          if (config.delimiter) {
            productsToProcess = data
              .split(config.delimiter)
              .filter(Boolean)
              .map((p) => p.trim());
            console.debug("Split QR code into products:", productsToProcess);
          }
        } else {
          console.debug("No matching posScanConfig found for QR code:", data);
        }
      } else {
        console.debug("No posScanConfigs available");
      }

      for (const productData of productsToProcess) {
        console.debug("Processing product:", productData);

        let selectedConfig = null;
        if (posConfig?.length === 1) {
          selectedConfig = posConfig[0];
        } else {
          const posConfigItem = posConfig?.filter((item) => productData.startsWith(item.startsWith));
          if (posConfigItem && posConfigItem.length > 0) {
            selectedConfig = posConfigItem[0];
          }
        }

        let formulaForThisProduct;
        let configForThisProduct = selectedConfig || {};

        if (selectedConfig) {
          try {
            formulaForThisProduct = JSON.parse(selectedConfig.formula);
            formulaForThisProduct.calculateTax = selectedConfig.calculateTax || "N";
          } catch (err) {
            console.warn("Invalid formula JSON for config, falling back to raw.", err);
            formulaForThisProduct = {
              property: { "product.value": { position: 1, length: productData.length } },
            };
            configForThisProduct = {};
          }
        } else {
          formulaForThisProduct = {
            property: { "product.value": { position: 1, length: productData.length } },
          };
          configForThisProduct = {};
        }

        const scannedItem = await getProduct(formulaForThisProduct, productData, tillData, configForThisProduct);

        if (!scannedItem) {
          console.debug("getProduct returned no item for:", productData);
          continue;
        }

        const tempCart = {
          ...(cart && typeof cart === "object" ? cart : {}),
          items: [scannedItem],
        };

        const isPreOrder = window.location.pathname.includes("/preorder");
        const shouldCheckStock = navigator.onLine && tillData?.tillAccess?.csBunit?.allowNegativeStock !== "Y" && !isPreOrder;

        const customMix = localStorage.getItem("customMix");
        if (shouldCheckStock) {
          const stockOk = await stock({
            cart: tempCart,
            setCart,
            tillData,
            setProductStock,
            isFinalValidation: false,
            isCompleteSale: true,
            setShowCompleteSaleStock,
            setCompleteSaleStockData: mergeCompleteSaleStockData,
            customMixHandler: false,
          });

          if (!stockOk) {
            console.debug(`Skipping ${scannedItem.name || scannedItem.value} due to insufficient stock`);
            continue;
          }
          setCustomMixItems((prev) => [...prev, scannedItem]);
        } else {
          setCustomMixItems((prev) => [...prev, scannedItem]);
        }
      }

      console.debug("All products processed successfully.");
    } catch (error) {
      localStorage.removeItem("productSegment");
      console.error("Error processing QR code:", error, "Data:", data);
    }
  };

  useEffect(() => {
    window.addEventListener("keydown", handleKeyDown);
    return () => {
      dataString = "";
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, []); // Empty dependency array is fine here since tillData is static

  return null;
};

export default BarCodeHandler;
